import React, { useState } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { UserAuth } from '../context/AutContext';
import { db } from '../firebase';
import { arrayUnion, doc, updateDoc } from 'firebase/firestore';

const Movie = ({ item }) => {
  const [like, setLike] = useState(false);
  const [saved, setSaved] = useState(false);
  const { user } = UserAuth();

  const movieID = doc(db, 'users', `${user?.email}`);

  const saveShow = async () => {
    if (user?.email) {
      setLike(!like);
      setSaved(true);
      await updateDoc(movieID, {
        savedShows: arrayUnion({
          id: item.id,
          title: item.title,
          img: item.backdrop_path,
        }),
      });
    } else {
      alert('Please log in to save a movie');
    }
  };

  return (
    <div className='w-[200px] sm:w-[240px] md:w-[240px] lg:w-[280px] inline-block cursor-pointer relative p-2'>
      <img
        className='w-full h-auto block'
        src={`https://image.tmdb.org/t/p/w500/${item?.backdrop_path}`}
        alt={item?.title}
      />
      <div className='hidden sm:block absolute top-0 left-0 w-full h-full hover:bg-black/80 opacity-0 hover:opacity-100 text-white'>
        <p className='hidden sm:flex white-space-normal text-xs md:text-sm font-bold justify-center items-center h-full text-center'>
          {item?.title}
        </p>
        <p onClick={saveShow}>
          {like ? (
            <FaHeart className='hidden sm:block absolute top-4 left-4 text-gray-300' />
          ) : (
            <FaRegHeart className='hidden sm:block absolute top-4 left-4 text-gray-300' />
          )}
        </p>
      </div>
      <div className='flex justify-between p-2'>
        <div>
          <p className='flex sm:hidden white-space-normal text-white text-[8px] md:text-sm font-bold items-center h-full text-center'>
            {item?.title}
          </p>
        </div>
      <div>
      <p onClick={saveShow}>
          {like ? (
            <FaHeart className='block sm:hidden text-gray-300' />
          ) : (
            <FaRegHeart className='block sm:hidden text-gray-300' />
          )}
        </p>
      </div>        
      </div>
    </div>
  );
};

export default Movie;